<!-- Litmus service availability down modal -->
<div class="modal fade" id="litmusServiceDownModal" tabindex="-1" role="dialog" data-backdrop="static"
  data-keyboard="false" aria-labelledby="litmusServiceDownModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close modal-close p-0 m-0" data-dismiss="modal" qid="litmus-unavail-1"
          [attr.aria-label]="'SHARED.GENERIC_LTI.LITMUS_DOWN_CLOSE' | translate">
          <i class="nemo-font nemo-close-new" aria-hidden="true"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="text-center">
          <i class="nemo-font nemo-info info-icon" aria-hidden="true"></i>
          <p class="litmus-down-text">
            {{ 'SHARED.GENERIC_LTI.LITMUS_DOWN_TEXT' | translate }}
          </p>
          <p class="litmus-down-description px-3">
            {{ litmusUnavailModalDesc | translate }}
          </p>
          <button type="button" class="btn close-btn" data-dismiss="modal" qid="litmus-unavail-2"
            [attr.aria-label]="'SHARED.GENERIC_LTI.LITMUS_DOWN_CLOSE' | translate">
            {{ 'SHARED.GENERIC_LTI.LITMUS_DOWN_CLOSE' | translate }}
          </button>
        </div>
      </div>

      <div class="modal-footer">
        <img class="svg-icon w-100" alt="" src='{{imageBasePath}}assets/img/litmus-down.svg'/>
      </div>
    </div>
  </div>
</div>